<template>
  <v-container fluid full-height grid-list-md>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="customerName"
                label="Customer Name"
                type="text"
                v-model="queryParams.customerName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="customerCode"
                label="Customer Code"
                type="text"
                v-model="queryParams.customerCode"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="issueNo"
                label="Invoice No."
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
                <v-autocomplete
                  v-model="queryParams.currencyId"
                  :items="currencyList"
                  color="blue-grey lighten-2"
                  label="Choose Currency..."
                  item-text="code"
                  menu-props="auto"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="saleList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <tr @click="props.expanded = !props.expanded">
                <td>{{ props.item.createdDateInMilliSeconds | format-ms-date-time }}</td>
                <td>{{ props.item.customer.code}}</td>
                <td>{{ props.item.customer.name}}</td>
                <td>{{ props.item.saleNo}}</td>
                <td>{{ props.item.shop.name}}</td>
                <td>{{ props.item.customer.creditLevel.periodDays}}</td>
                <td>{{ props.item.currencyCode }}</td>
                <td>{{ props.item.netAmount | decFormat}}</td>
                <td>{{ props.item.creditPaidAmount | decFormat }}</td>
                <td>{{ props.item.netAmount - props.item.creditPaidAmount | decFormat }}</td>
                <td v-if="roleName == 'SALE_MANAGER'">
                  <v-btn color="primary" @click.stop="showCreditPaymentDialog(props.item)">payment</v-btn>
                </td>
                <td v-else>
                  <v-btn
                    :disabled="props.item.creditPaidAmount <= 0"
                    color="primary"
                    @click.stop="print(props.item.id,true)"
                  >Print</v-btn>
                </td>
              </tr>
            </template>
            <template slot="expand" slot-scope="props">
              <v-card class="elevation-1">
                <v-card-text>
                  <v-data-table
                    :headers="subHeaders"
                    :items="props.item.creditCashFlows"
                    item-key="props.item.id"
                    hide-actions
                    class="elevation-10"
                  >
                    <template slot="items" slot-scope="subprops">
                      <td
                        class="text-xs"
                      >{{ subprops.item.paidDateInMilliSeconds | format-ms-date-time}}</td>
                      <td class="text-xs">{{ subprops.item.paidAmount  | decFormat}}</td>
                      <td class="text-xs">{{ subprops.item.description }}</td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs_" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="wholeSaleList"
            class="elevation-1"
            :loading="wsShowListLoading"
            :total-items="wsTotalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="wsPagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <tr @click="props.expanded = !props.expanded">
                <td>{{ props.item.createdDateInMilliSeconds | format-ms-date-time }}</td>
                <td>{{ props.item.customer.code}}</td>
                <td>{{ props.item.customer.name}}</td>
                <td>{{ props.item.issueNo}}</td>
                <td>{{ props.item.shop.name}}</td>
                <td>{{ props.item.customer.creditLevel.periodDays}}</td>
                <td>{{ props.item.currencyCode }}</td>
                <td>{{ props.item.netAmount  | decFormat }}</td>
                <td>{{ props.item.creditPaidAmount | decFormat }}</td>
                <td>{{ props.item.netAmount - props.item.creditPaidAmount | decFormat }}</td>
                <td v-if="roleName == 'SALE_MANAGER'">
                  <v-btn
                    color="primary"
                    @click.stop="showWholeSaleCreditPaymentDialog(props.item)"
                  >payment</v-btn>
                </td>
                <td v-else>
                  <v-btn
                    :disabled="props.item.creditPaidAmount <= 0"
                    color="primary"
                    @click.stop="print(props.item.id,false)"
                  >Print</v-btn>
                </td>
              </tr>
            </template>
            <template slot="expand" slot-scope="props">
              <v-card class="elevation-1">
                <v-card-text>
                  <v-data-table
                    :headers="subHeaders"
                    :items="props.item.creditCashFlows"
                    item-key="props.item.id"
                    hide-actions
                    class="elevation-10"
                  >
                    <template slot="items" slot-scope="subprops">
                      <td
                        class="text-xs"
                      >{{ subprops.item.paidDateInMilliSeconds | format-ms-date-time}}</td>
                      <td class="text-xs">{{ subprops.item.paidAmount }}</td>
                      <td class="text-xs">{{ subprops.item.description }}</td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- CreditCashFlow list dialog -->
    <v-dialog v-model="creditPaymentDialogFlag" max-width="1000px">
      <v-form ref="paymentModalForm" lazy-validation @submit.prevent="save">
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="headline">Credit Cash Payment</div>
            </div>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <div>
              <p class="font-weight-black">Invoice No: {{selectedSaleInvoice.saleNo}}</p>
              <p
                class="font-weight-black"
                v-if="selectedSaleInvoice.customer"
              >Customer Name: {{selectedSaleInvoice.customer.name}}</p>
              <p
                class="font-weight-black"
                v-if="selectedSaleInvoice.customer"
              >Customer Code: {{selectedSaleInvoice.customer.code}}</p>
              <p
                class="font-weight-black"
              >Created Date: {{selectedSaleInvoice.createdDateInMilliSeconds | format-ms-date-time}}</p>
              <p class="font-weight-black">Net Amount: {{selectedSaleInvoice.netAmount | decFormat }}</p>
              <p class="font-weight-black">Currency: {{selectedSaleInvoice.currencyCode}}</p>
              <p
                class="font-weight-black"
              >Credit Paid Amount: {{selectedSaleInvoice.creditPaidAmount | decFormat }}</p>
              <p
                class="font-weight-black"
              >Remain Amount: {{selectedSaleInvoice.netAmount - selectedSaleInvoice.creditPaidAmount | decFormat }}</p>
            </div>
            <!-- CreditCashFlow List Section -->
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :headers="subHeaders"
                  :items="selectedSaleInvoice.creditCashFlows"
                  class="elevation-1"
                  :item-per-page="5"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.paidDateInMilliSeconds | format-ms-date-time}}</td>
                    <td>{{ props.item.paidAmount | decFormat }}</td>
                    <td>{{ props.item.description }}</td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
            <v-divider></v-divider>
            <br />
            <v-flex>
              <div>
                <v-text-field
                  outline
                  name="paidAmount"
                  label="Pay Amount"
                  min="0"
                  type="number"
                  :rules="rules.payAmountRules"
                  v-model="creditCashFlow.paidAmount"
                ></v-text-field>
              </div>
              <div>
                <v-textarea
                  outline
                  name="description"
                  label="Description"
                  type="text"
                  :rules="rules.descriptionRules"
                  v-model="creditCashFlow.description"
                ></v-textarea>
              </div>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" :loading="saveLoading" @click="save">
              Save
              <v-icon right>save</v-icon>
            </v-btn>
            <v-btn
              color="error"
              @click="creditPaymentDialogFlag = !creditPaymentDialogFlag,removeSelectedSale()"
            >
              Close
              <v-icon right>clear</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- WholeSaleCreditCashFlow list dialog -->
    <v-dialog v-model="wholeSaleCreditPaymentDialogFlag" max-width="1000px">
      <v-form ref="paymentModalForm" lazy-validation @submit.prevent="save">
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="headline">Whole Sale Credit Cash Payment</div>
            </div>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <div>
              <p class="font-weight-black">Invoice No: {{selectedWholeSaleInvoice.issueNo}}</p>
              <p
                class="font-weight-black"
                v-if="selectedWholeSaleInvoice.customer"
              >Customer Name: {{selectedWholeSaleInvoice.customer.name}}</p>
              <p
                class="font-weight-black"
                v-if="selectedWholeSaleInvoice.customer"
              >Customer Code: {{selectedWholeSaleInvoice.customer.code}}</p>
              <p
                class="font-weight-black"
              >Created Date: {{selectedWholeSaleInvoice.createdDateInMilliSeconds | format-ms-date-time}}</p>
              <p class="font-weight-black">Net Amount: {{selectedWholeSaleInvoice.netAmount | decFormat }}</p>
              <p class="font-weight-black">Currency: {{selectedWholeSaleInvoice.currencyCode}}</p>
              <p
                class="font-weight-black"
              >Credit Paid Amount: {{selectedWholeSaleInvoice.creditPaidAmount | decFormat }}</p>
              <p
                class="font-weight-black"
              >Remain Amount: {{selectedWholeSaleInvoice.netAmount - selectedWholeSaleInvoice.creditPaidAmount | decFormat }}</p>
            </div>
            <!-- WholeSaleCreditCashFlow List Section -->
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :headers="subHeaders"
                  :items="selectedWholeSaleInvoice.creditCashFlows"
                  class="elevation-1"
                  :item-per-page="5"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.paidDateInMilliSeconds | format-ms-date-time}}</td>
                    <td>{{ props.item.paidAmount | decFormat  }}</td>
                    <td>{{ props.item.description }}</td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
            <v-divider></v-divider>
            <br />
            <v-flex>
              <div>
                <v-text-field
                  outline
                  name="paidAmount"
                  label="Pay Amount"
                  min="0"
                  type="number"
                  :rules="rules.payAmountRules"
                  v-model="creditCashFlow.paidAmount"
                ></v-text-field>
              </div>
              <div>
                <v-textarea
                  outline
                  name="description"
                  label="Description"
                  type="text"
                  :rules="rules.descriptionRules"
                  v-model="creditCashFlow.description"
                ></v-textarea>
              </div>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" :loading="saveLoading" @click="save">
              Save
              <v-icon right>save</v-icon>
            </v-btn>
            <v-btn
              color="error"
              @click="wholeSaleCreditPaymentDialogFlag = !wholeSaleCreditPaymentDialogFlag,removeSelectedSale()"
            >
              Close
              <v-icon right>clear</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!--Retail Sale Message dialog -->
    <v-dialog
      v-model="saleMessageDialogBox"
      max-width="500px"
      @keydown.enter="saleMessageDialogBox=false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert :type="saleSuccessFlag? 'success': 'warning'" :value="true">
              <h3>{{ responseMessage }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions v-if="saleSuccessFlag">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="getCreditSaleList(),print(selectedSaleInvoice.id,true)"
          >Print</v-btn>
          <v-btn
            color="error"
            flat
            @click="getCreditSaleList(),saleMessageDialogBox=false,removeSelectedSale()"
          >Close</v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="saleMessageDialogBox=false,removeSelectedSale()">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Whole Sale Message dialog -->
    <v-dialog
      v-model="wholeSaleMessageDialogBox"
      max-width="500px"
      @keydown.enter="wholeSaleMessageDialogBox=false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert :type="wholeSaleSuccessFlag? 'success': 'warning'" :value="true">
              <h3>{{ responseMessage }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions v-if="wholeSaleSuccessFlag">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="getWholeSaleList(),print(selectedWholeSaleInvoice.id, false)"
          >Print</v-btn>
          <v-btn
            color="error"
            flat
            @click="getWholeSaleList(),wholeSaleMessageDialogBox=false,removeSelectedSale()"
          >Close</v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            flat
            @click="wholeSaleMessageDialogBox=false,removeSelectedSale()"
          >Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { creditCashFlowService } from "../../services/credit-cash-flow-service";
import { saleService } from "../../services/sale-service";
import { wholeSaleService } from "../../services/whole-sale-service";
import { Sale } from "../../models/model";
import { CreditCashFlow } from "../../models/model";
import { WholeSaleHeader } from "../../models/model";
import { CreditCashFlowFormRules } from "../../helpers/validation-rules";
import { currencyService } from "../../services/currency-service";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";


export default {
  name: "CreditCashFlowList",

  components: { Loading },
  data: () => ({
    rules: new CreditCashFlowFormRules(),
    showListLoading: false,
    wsShowListLoading: false,
    breadcrumbs: [
      {
        text: "Credit Cash Flow",
        disabled: true
      },
      {
        text: "Retail",
        disabled: true
      }
    ],
    breadcrumbs_: [
      {
        text: "Credit Cash Flow",
        disabled: true
      },
      {
        text: "Whole Sale",
        disabled: true
      }
    ],
    headers: [
      { text: "Created Date", align: "left", value: "createdDate" },
      { text: "Customer Code", value: "customer.code" },
      { text: "Customer Name", value: "customer.name" },
      { text: "Invoice No.", value: "saleNo" },
      { text: "Shop Name", value: "shop.name" },
      { text: "Period Days", value: "customer.creditLevel.periodDays" },
      { text: "Currency", value: "currencyCode" },
      { text: "Net Amount", value: "netAmount" },
      { text: "Credit Paid Amount", value: "creditPaidAmount" },
      { text: "Remain Amount", value: "remainAmount", sortable: false },
      { text: "Action", sortable: false }
    ],
    subHeaders: [
      { text: "Pay Date", sortable: false },
      { text: "Paid Amount", sortable: false },
      { text: "Description", sortable: false }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "createdDate",
      totalItems: 0
    },
    wsPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "createdDate",
      totalItems: 0
    },
    saleList: [],
    wholeSaleList: [],
    totalRows: 0,
    wsTotalRows: 0,
    queryParams: {
      customerName: "",
      customerCode: "",
      payType: "",
      issueNo: "",
      currencyId: "",
      status: ""
    },
    currencyList: [],
    roleName: "",
    selectedSaleInvoice: new Sale(),
    selectedWholeSaleInvoice: new WholeSaleHeader(),
    creditCashFlow: new CreditCashFlow(),
    creditPaymentDialogFlag: false,
    wholeSaleCreditPaymentDialogFlag: false,
    responseMessage: "",
    isLoading: false,

    saveLoading: false,
    saleMessageDialogBox: false,
    wholeSaleMessageDialogBox: false,
    saleSuccessFlag: false,
    wholeSaleSuccessFlag: false,
    fullPage: true
  }),
  watch: {
    pagination: {
      handler() {
        this.getCreditSaleList();
      },
      deep: true
    },
    wsPagination: {
      handler() {
        this.getWholeSaleList();
      },
      deep: true
    }
  },
  created() {
    //for deep linking
    if (this.$route.query.customerName) {
      this.queryParams.customerName = this.$route.query.customerName;
    }
    if (this.$route.query.customerCode) {
      this.queryParams.customerCode = this.$route.query.customerCode;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    if (this.$route.query.wspage) {
      this.wsPagination.page = this.$route.query.wspage;
    }
    if (this.$route.query.wssize) {
      this.wsPagination.size = this.$route.query.wssize;
    }
    let user = JSON.parse(localStorage.getItem("user"));
    this.roleName = user.roleName;
    this.getActiveCurrency()
    .finally(() => {
        this.onSearch();
    });
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.queryParams.wspage = this.wsPagination.page;
      this.queryParams.wssize = this.wsPagination.rowsPerPage;
      this.$router.replace({
        name: "CreditCashFlows",
        query: this.queryParams
      });
      this.getCreditSaleList();
      this.getWholeSaleList();
    },
    getCreditSaleList() {
      this.queryParams.payType = "CREDIT";
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      if (this.roleName == "SALE_MANAGER") {
        saleService
          .getUnfinishedCreditSaleList(
            this.queryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then(res => {
            if (res.data) {
              this.saleList = res.data.saleList;
              this.totalRows = res.data.totalElements;
            }
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      } else if (this.roleName == "ADMIN" || this.roleName == "BRANCH_ADMIN") {
        saleService
          .getSaleList(
            this.queryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then(res => {
            if (res.data) {
              this.saleList = res.data.saleList;
              this.totalRows = res.data.totalElements;
            }
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      }
    },
    getWholeSaleList() {
      this.wsShowListLoading = true;
      let order = this.wsPagination.descending ? "desc" : "asc";
      if (this.roleName == "SALE_MANAGER") {
        wholeSaleService
          .getUnfinishedWholeSale(
            this.queryParams,
            this.wsPagination.page,
            this.wsPagination.rowsPerPage,
            this.wsPagination.sortBy + "," + order
          )
          .then(res => {
            if (res.data) {
              this.wholeSaleList = res.data.wholeSaleHeaderList;
              this.wsTotalRows = res.data.totalElements;
            }
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.wsShowListLoading = false;
          });
      } else if (this.roleName == "ADMIN" || this.roleName == "BRANCH_ADMIN") {
        this.queryParams.status = "FINISHED";
        wholeSaleService
          .getWholeSaleList(
            this.queryParams,
            this.wsPagination.page,
            this.wsPagination.rowsPerPage,
            this.wsPagination.sortBy + "," + order
          )
          .then(res => {
            if (res.data) {
              this.wholeSaleList = res.data.wholeSaleHeaderList;
              this.wsTotalRows = res.data.totalElements;
            }
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.wsShowListLoading = false;
          });
      }
    },
    getActiveCurrency() {
      return currencyService.getCurrencyByStatus('ACTIVE')
      .then(res => {
        if(res.data){
          this.currencyList = res.data;
          let c = commonService.search("defaultCurrency",true,this.currencyList);
          if(c){
            this.queryParams.currencyId = c.id;
          }
        }
      })
      .catch((err) => {
        if (err.response.data) {
          this.responseError = err.responseError.data.message;
        }
      });
    },
    showCreditPaymentDialog(sale) {
      this.removeSelectedSale();
      this.creditCashFlow = new CreditCashFlow();
      this.selectedSaleInvoice = sale;
      this.creditPaymentDialogFlag = true;
    },
    showWholeSaleCreditPaymentDialog(wholeSaleHeader) {
      this.removeSelectedSale();
      this.creditCashFlow = new CreditCashFlow();
      this.selectedWholeSaleInvoice = wholeSaleHeader;
      this.wholeSaleCreditPaymentDialogFlag = true;
    },
    save() {
      if (!this.$refs.paymentModalForm.validate()) {
        return;
      }
      this.saveLoading = true;

      if (this.selectedSaleInvoice.id) {
        this.creditCashFlow.saleId = this.selectedSaleInvoice.id;
      }
      if (this.selectedWholeSaleInvoice.id) {
        this.creditCashFlow.wholeSaleId = this.selectedWholeSaleInvoice.id;
      }
      creditCashFlowService
        .save(this.creditCashFlow)
        .then(res => {
          if (res) {
            this.creditCashFlow = res.data;
            this.saleSuccessFlag = false;
            this.saleMessageDialogBox = false;
            this.creditPaymentDialogFlag = false;
            this.wholeSaleCreditPaymentDialogFlag = false;
            this.wholeSaleSuccessFlag = false;
            this.wholeSaleMessageDialogBox = false;
            this.saveLoading = false;
            this.responseMessage = "Payment Success!";
            if (this.selectedSaleInvoice.id) {
              this.saleSuccessFlag = true;
              this.saleMessageDialogBox = true;
            }
            if (this.selectedWholeSaleInvoice.id) {
              this.wholeSaleSuccessFlag = true;
              this.wholeSaleMessageDialogBox = true;
            }
          }
        })
        .catch(err => {
          this.saveLoading = false;
          console.log(err);
          if (err.response.data) {
            this.responseMessage = err.response.data.message;
            if (this.selectedSaleInvoice.id) {
              this.saleSuccessFlag = true;
              this.saleMessageDialogBox = true;
            }
            if (this.selectedWholeSaleInvoice.id) {
              this.wholeSaleSuccessFlag = true;
              this.wholeSaleMessageDialogBox = true;
            }
          }
        });
    },
    print(id, isSaleFlag) {
      this.isLoading = true;
      creditCashFlowService
        .printCreditCashFlowInvoice(id, isSaleFlag)
        .then(res => {
          var blob = res;
          creditCashFlowService.showWindowDialog(
            blob,
            "CreditCashFlowInvoice-" + id
          );
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
          this.saleMessageDialogBox = false;
          this.wholeSaleMessageDialogBox = false;
          this.removeSelectedSale();
        });
    },
    removeSelectedSale() {
      this.selectedSaleInvoice = new Sale();
      this.selectedWholeSaleInvoice = new WholeSaleHeader();
    }
  }
};
</script>